<template>
  <div class="summary">
    <div class="summary-row">
      <div class="summary-row-description">
        <div class="text-bold text-blue">My Equipment</div>
        <div class="text-bold">My custom security system</div>
      </div>
      <div>
        <div class="amount text-blue">
          ${{ formatCurrency(system.subtotal) }}
        </div>
        <div class="amount-description text-bold text-blue">
          <div>Equipment Total</div>
          <div style="font-size: .9em; font-weight: normal;">with discounts</div>
        </div>
      </div>
    </div>

    <div class="summary-content">
      <ul>
        <li>Professional Installation</li>
        <li>30 Day money back guarantee</li>
        <li>Warranty</li>
      </ul>
    </div>

    <div class="divider"></div>
    <div class="summary-content">&nbsp;</div>

    <!-- DISCOUNTS -->

    <div class="summary-row">
      <div class="summary-row-description">
        <div class="text-bold text-blue">Discounts</div>
        <div class="text-bold">All the discounts you're receiving</div>
      </div>
    </div>

    <div class="mt-5">&nbsp;</div>
    <div class="summary-content mt-5">
      <div v-for="discount in system.discounts" :key="discount.title" class="mb-5">
        <div class="summary-row">
          <div>
            <div class="text-bold">{{ discount.title }}</div>
            <div>{{ discount.description }}</div>
          </div>
          <div class="text-bold text-blue text-right">-${{ formatCurrency(discount.amount) }}</div>
        </div>
      </div>
    </div>

    <div class="divider"></div>
    <div class="summary-content">&nbsp;</div>

    <!-- MY PLAN -->

    <div class="summary-row">
      <div class="summary-row-description">
        <div class="text-bold text-blue">My Plan</div>
        <div class="text-bold">{{ system.monitoringPlan.name }}</div>
      </div>
      <div>
        <div class="amount text-blue">
          ${{ formatCurrency(system.monitoringPlan.price) }}
        </div>
        <div class="amount-description text-bold text-blue">Per month</div>
      </div>
    </div>

    <div class="summary-content">
      <div>{{ system.monitoringPlan.description }}</div>
    </div>
    <!-- See all plans and features link -->
  </div>
</template>

<script>
import formatCurrency from "../Libraries/formatCurrency";
export default {
  props: {
    system: {
      type: Object,
      required: true,
    },
  },
  methods: {
    formatCurrency,
  },
};
</script>

<style lang="scss" scoped>
.summary {
  padding: 4rem 2.5rem;
  @media (max-width: 768px) {
    padding: 1rem 2rem;
  }
}

.summary-row {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  align-items: top;
  margin-bottom: 2rem;
  &:last-of-type {
    margin-bottom: 0;
  }
}

.summary-row-description {
  /* min-width: 300px; */
}

.summary-content-bottom-margin {
  margin-bottom: 2.5rem;
}

.summary-content {
  margin: -1.5rem 0 2.5rem 0;
  ul {
    padding-left: 0.5rem;
  }
}

.amount {
  font-size: 2rem;
  font-weight: 300;
  text-align: right;
  @media (max-width: 768px) {
    font-size: 1.5rem;
    margin-left: 1rem;
  }
}

.amount-description {
  text-align: right;
  @media (max-width: 768px) {
    /* display: none; */
    font-size: .8rem;
    margin-left: 1rem;
  }
}

.divider {
  height: 1px;
  background: #cecece;
  width: 100;
}
</style>
